import React from 'react';
import { Container, Box, Typography, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import Hero from '../components/Hero';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import { useState } from 'react';

const projects = Array.from({ length: 6 }).map((_, i) => ({
  id: i+1,
  title: `Project ${i+1}: Efficiency Retrofit`,
  before: `/src/assets/images/gallery-${String(i+1).padStart(2,'0')}.svg`,
  after: `/src/assets/images/gallery-${String(i+7).padStart(2,'0')}.svg`,
  description: 'Upgraded to variable-speed equipment, sealed ducts, and added smart controls for measurable savings.'
}));

export default function CaseStudies() {
  const m = meta.caseStudies;
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);

  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="Case Studies & Recent Projects" subtitle="Before-and-after results from Bloomington, Ellettsville, Bedford, Martinsville, and Spencer." bgImage="/assets/images/hero-case-studies.svg" />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={3}>
          {projects.map(p => (
            <Grid item xs={12} md={4} key={p.id}>
              <Box sx={{ border: '1px solid #eee', borderRadius: 2, overflow:'hidden' }}>
                <Box component="img" src={p.after} alt={p.title} sx={{ width:'100%' }} />
                <Box sx={{ p: 2 }}>
                  <Typography variant="h6">{p.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{p.description}</Typography>
                  <Button sx={{ mt: 1 }} onClick={()=>{setActive(p); setOpen(true);}}>View Details</Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Dialog open={open} onClose={()=>setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>{active?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {active?.description} Commissioning reports and verification testing available upon request.
          </DialogContentText>
          <Box sx={{ display:'flex', gap:2, mt:2, flexDirection:{xs:'column', md:'row'} }}>
            <Box sx={{ flex:1 }}>
              <Typography variant="subtitle2">Before</Typography>
              <Box component="img" src={active?.before} alt="Before" sx={{ width:'100%', borderRadius:1, border:'1px solid #eee' }} />
            </Box>
            <Box sx={{ flex:1 }}>
              <Typography variant="subtitle2">After</Typography>
              <Box component="img" src={active?.after} alt="After" sx={{ width:'100%', borderRadius:1, border:'1px solid #eee' }} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
